import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { deleteDepartmentById, getDiagConceptServiceById, getDiagnosticConceptTemplateById, markDeleteDiagnosticConceptService, pagingDiagnosticConceptTemplate, saveOrUpdateDiagConceptService, saveOrUpdateDiagnosticConceptTemplate, searchServiceByPage } from "app/services/DiagnosticConceptTemplateService";
import { checkSearchObject } from "app/common/LocalFunction";

export default class DiagnosticConceptTemplateStore {
    searchDiagnosticConceptTemplate = new SearchObject()
    pageDiagnosticConceptTemplate = null
    selectDiagnosticConceptTemplate = null
    recentlyUpdated = false;
    openFormSaveOrUpdate = false;
    openFormSaveOrUpdateChild = false;
    openConfirmDelete = false;


    constructor() {
        makeAutoObservable(this);
    }

    pagingDiagnosticConceptTemplate = async () => {
        try {
            const res = await pagingDiagnosticConceptTemplate(this.searchDiagnosticConceptTemplate)
            this.pageDiagnosticConceptTemplate = res.data
        } catch (error) {
            console.error(error);
            toast.error("Lấy dữ liệu có lỗi");
        }
    }

    searchServiceByPage = async () => {
        try {
            const res = await searchServiceByPage(this.searchDiagnosticConceptTemplate)
            this.pageDiagnosticConceptTemplate = res.data
        } catch (error) {
            console.error(error);
            toast.error("Lấy dữ liệu có lỗi");
        }
    }

    saveOrUpdateDiagnosticConceptTemplate = async (diagnosticConceptTemplate) => {
        try {
            await saveOrUpdateDiagnosticConceptTemplate(diagnosticConceptTemplate)
            toast.success("Thêm mới thành công!");
            this.handleClosePopup();
            // this.searchServiceByPage();
            this.pagingDiagnosticConceptTemplate()
            this.recentlyUpdated = true;
        } catch (error) {
            console.error(error);
            toast.error("Thêm dữ liệu có lỗi");
        }
    }

    saveOrUpdateDiagnosticConceptTemplateParent = async (diagnosticConceptTemplate) => {
        try {
            await saveOrUpdateDiagnosticConceptTemplate(diagnosticConceptTemplate)
            toast.success("Thêm mới thành công!");
            this.handleClosePopup();
            this.searchServiceByPage();
        } catch (error) {
            console.error(error);
            toast.error("Thêm dữ liệu có lỗi");
        }
    }

    saveOrUpdateDiagConceptService = async (diagnosticConceptTemplate) => {
        try {
            const res = await saveOrUpdateDiagConceptService(diagnosticConceptTemplate)
            toast.success("Thêm mới thành công!");
            this.handleClosePopup();
            this.searchServiceByPage();
        } catch (error) {
            console.error(error);
            toast.error("Thêm dữ liệu có lỗi");
        }
    }

    handleChangeFormSearchChild = (obj) => {
        if (obj) this.searchDiagnosticConceptTemplate = { ...this.searchDiagnosticConceptTemplate, ...obj }
        this.searchServiceByPage();
    }

    handleChangeFormSearch = (obj) => {
        if (obj) this.searchDiagnosticConceptTemplate = checkSearchObject(this.searchDiagnosticConceptTemplate, obj);
        this.pagingDiagnosticConceptTemplate();
        }

    handleDelete = (diagnosticConceptTemplate) => {
        this.selectDiagnosticConceptTemplate = { id: diagnosticConceptTemplate?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteDepartmentById(this.selectDiagnosticConceptTemplate?.id)
            .then(() => {
                toast.success("Xóa phiếu thành công!");
                this.handleClosePopup();
                this.pagingDiagnosticConceptTemplate();
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa phiếu có lỗi");
            })
    }

    handleConfirmDeleteChild = async () => {
        return await markDeleteDiagnosticConceptService(this.selectDiagnosticConceptTemplate?.id)
            .then(() => {
                toast.success("Xóa phiếu thành công!");
                this.handleClosePopup();
                this.searchServiceByPage();
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa phiếu có lỗi");
            })
    }

    handleOpenFormCreateOrEdit = async (diagnosticConceptTemplateId) => {
        if (Boolean(diagnosticConceptTemplateId)) {
            getDiagnosticConceptTemplateById(diagnosticConceptTemplateId).then(({ data }) => {
                this.selectDiagnosticConceptTemplate = data
                this.openFormSaveOrUpdate = true;
            })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectDiagnosticConceptTemplate = {};
            this.openFormSaveOrUpdate = true;
        }
    }

    handleOpenFormCreateOrEditChild = async (diagnosticConceptTemplateId) => {
        if (Boolean(diagnosticConceptTemplateId)) {
            getDiagConceptServiceById(diagnosticConceptTemplateId).then(({ data }) => {
                this.selectDiagnosticConceptTemplate = data
                this.openFormSaveOrUpdateChild = true;
            })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectDiagnosticConceptTemplate = {};
            this.openFormSaveOrUpdateChild = true;
        }
    }

    handleClosePopup = () => {
        this.openFormSaveOrUpdate = false;
        this.openFormSaveOrUpdateChild = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchDiagnosticConceptTemplate = new SearchObject();
        this.pageDiagnosticConceptTemplate = null;
        this.selectDiagnosticConceptTemplate = null;
        this.openConfirmDelete = false;
        this.openFormSaveOrUpdate = false;
        this.openFormSaveOrUpdateChild = false;
    }
}
